<template>
  <div class="loading-page flex flex-col items-center justify-center h-screen bg-white p-16">
    <div class="loading-container text-center">
      <div class="circular-loader mb-8">
        <div class="circular-loader-inner"></div>
      </div>
      <h2 class="text-2xl font-medium text-gray-800 mb-3">{{ $t('orgDashboard.loading.title') }}</h2>
      <p class="text-gray-600">{{ $t('orgDashboard.loading.message') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingPage',
  data() {
    return {
      isLoading: true,
    };
  },
  created() {
    this.checkUserOrganizations();
  },
  methods: {
    async checkUserOrganizations() {
      try {
        if (this.$store.state.auth && this.$store.state.auth.user) {
          const userId = this.$store.state.auth.user._id;
          const payload = {
            email: this.$store.state.auth.user.email,
            userId: userId,
          };
          
          // Fetch user's organizations
          await this.$store.dispatch("organization/fetchAllMyOrganizations", payload);
          
          // Get organizations from store
          const myOrganizations = this.$store.state.organization.myOrganizations;
          
          if (myOrganizations && 
              (Array.isArray(myOrganizations.superOrgs) && myOrganizations.superOrgs.length > 0 || 
               Array.isArray(myOrganizations.subOrgs) && myOrganizations.subOrgs.length > 0)) {
            
            // Try to get the last used organization from localStorage
            const lastOrgKey = `lastOrg_${userId}`;
            const lastOrgId = localStorage.getItem(lastOrgKey);
            let organizationIdOrSlug = null;
            let foundLastOrg = false;
            
            // Check if the last used org exists and is still available
            if (lastOrgId) {
              // Check in super orgs
              if (Array.isArray(myOrganizations.superOrgs)) {
                const lastSuperOrg = myOrganizations.superOrgs.find(org => 
                  org && (org.slug === lastOrgId || org._id === lastOrgId) && org.status !== 'DEACTIVATED'
                );
                
                if (lastSuperOrg) {
                  organizationIdOrSlug = lastSuperOrg.slug || lastSuperOrg._id;
                  foundLastOrg = true;
                }
              }
              
              // Check in sub orgs if not found in super orgs
              if (!foundLastOrg && Array.isArray(myOrganizations.subOrgs)) {
                const lastSubOrg = myOrganizations.subOrgs.find(org => 
                  org && org.status !== 'DEACTIVATED' && 
                  org.status === 'active' && 
                  org.organization && 
                  Array.isArray(org.organization) && 
                  org.organization.length > 0 && 
                  (org.organization[0].slug === lastOrgId || org.organization[0]._id === lastOrgId)
                );
                
                if (lastSubOrg) {
                  organizationIdOrSlug = lastSubOrg.organization[0].slug || lastSubOrg.organization[0]._id;
                  foundLastOrg = true;
                }
              }
            }
            
            // If last org not found, fallback to first available org
            if (!foundLastOrg) {
              // First check super orgs
              if (Array.isArray(myOrganizations.superOrgs) && myOrganizations.superOrgs.length > 0) {
                const firstActiveOrg = myOrganizations.superOrgs.find(org => org && org.status !== 'DEACTIVATED');
                if (firstActiveOrg) {
                  organizationIdOrSlug = firstActiveOrg.slug || firstActiveOrg._id;
                }
              }
              
              // If no super org found, check sub orgs
              if (!organizationIdOrSlug && Array.isArray(myOrganizations.subOrgs) && myOrganizations.subOrgs.length > 0) {
                const firstActiveSubOrg = myOrganizations.subOrgs.find(
                  org => org && org.status !== 'DEACTIVATED' && 
                        org.status === 'active' && 
                        org.organization && 
                        Array.isArray(org.organization) && 
                        org.organization.length > 0
                );
                
                if (firstActiveSubOrg) {
                  organizationIdOrSlug = firstActiveSubOrg.organization[0].slug || 
                                        firstActiveSubOrg.organization[0]._id;
                }
              }
            }
            
            // Redirect to org dashboard if we found an org
            if (organizationIdOrSlug) {
              // Save the selected org to localStorage for next time
              localStorage.setItem(lastOrgKey, organizationIdOrSlug);
              window.location.href = `/organization/${organizationIdOrSlug}/dashboard`;
              return;
            }
          }
          
          // If no orgs found or no active orgs, redirect to create org page
          this.$router.push('/organization/create');
        } else {
          // If no user is logged in, redirect to login page
          this.$router.push('/login');
        }
      } catch (error) {
        console.error('Error in checkUserOrganizations:', error);
        // On error, redirect to create organization page
        this.$router.push('/organization/create');
      }
    }
  }
};
</script>

<style scoped>
.circular-loader {
  position: relative;
  width: 90px;
  height: 90px;
  margin: 0 auto;
}

.circular-loader-inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 5px solid rgba(0, 0, 0, 0.08);
  border-top-color: #FBBF15; /* App's primary color from themeConfig */
  animation: spin 1.2s infinite cubic-bezier(0.41, 0.26, 0.54, 0.94);
  box-shadow: 0 4px 12px rgba(251, 191, 21, 0.15);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
